export default {
    BASE_URL: '/inquiry',
    api: [
        {
            name: 'dataList',
            desc: '业务审核列表',
            method: 'GET',
            path: '/list'
        },
        {
            name: 'detail',
            desc: '业务审核详情',
            method: 'GET',
            path: '/detail'
        },
        {
            name: 'audit',
            desc: '审核询价单',
            method: 'POST',
            path: '/audit'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/apis/business/review.js